<template>
  <div>
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>项目任务</h4>
      </div>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="请输入名称/编号/备注"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'in:state|array-integer#and': '0,1',
                'regex:name|string#or': searchValue,
                'regex:code|string#or': searchValue,
                'regex:memo|string#or': searchValue,
                sortField: 'createTime',
                sortOrder: 'desc',
                beanName: 'projectTask',
                title: '项目任务'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
          :row-class-name="osg.lastRowClassName"
        >
          <c-table :fields="extFields">
            <template slot="fieldData">
              <el-table-column
                prop="fieldData"
                label="消息内容"
                width="120px"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <el-button @click="openFieldData(scope.row.fieldList, scope.row.fieldData)">
                    点击查看
                  </el-button>
                </template>
              </el-table-column>
            </template>
          </c-table>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <!-- <el-dropdown-item @click.native="doEdit(scope.row)">
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="doEnable(scope.row._id)">
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="doDisable(scope.row._id)">
                    禁用
                  </el-dropdown-item> -->
                  <el-dropdown-item @click.native="doRemove(scope.row)">
                    归档
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="消息内容" :visible.sync="openFieldDataDialog" width="50%">
      <c-form
        :formData="fieldData"
        :fields="fieldList"
        :area="area"
        :options="options"
        @changeForm="osg.changeForm"
        ref="form"
        labelWidth="300px"
      ></c-form>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  data() {
    window.$this = this;
    return {
      tenantId: '',
      name: 'projectTask',
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: { exts: {} },
      extFields: [],
      extField: {},
      rules: this.$util.rules,
      options: {},
      area: {
        options: this.osg.areaList
      },
      openFieldDataDialog: false,
      fieldList: [],
      fieldData: {}
    };
  },
  async mounted() {
    this.doInit();
    this.osg.getFields('projectTask', () => {
      this.osg.getFpi();
      this.getData();
    });
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = { exts: {} };
    },
    getData() {
      let params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'in:state|array-integer#and': '0,1',
        'regex:name|string#or': this.searchValue,
        'regex:code|string#or': this.searchValue,
        'regex:memo|string#or': this.searchValue,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('biz/projectTask/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    // doEdit(row) {
    //   row = this.$util.deepCopy(row);
    //   this.$util.renderExtField(this.extFields, row);
    //   this.formData = row;
    //   this.openDetail = true;
    // },
    // doSave() {
    //   if (this.osg.validate()) {
    //     this.$util.saveExtField(this.extFields, this.formData);
    //     this.osg.ajax('biz/projectTask/insert.do', { data: JSON.stringify(this.formData) }, () => {
    //       this.doInit();
    //       this.getData();
    //       this.osg.toast('保存成功！');
    //     });
    //   }
    // },
    doRemove(row) {
      this.osg.confirm(`是否确认删除${row.name}？`, () => {
        this.osg.ajax('biz/projectTask/remove.do', { id: row._id }, () => {
          this.getData();
          this.osg.toast('操作成功');
        });
      });
    },
    openFieldData(fieldList, fieldData) {
      fieldList.map(field => {
        if (this.$util.isJson(field.frontEndConfig)) {
          field.frontEndConfig = JSON.parse(field.frontEndConfig);
        } else {
          field.frontEndConfig = {};
        }
      });
      this.fieldList = fieldList;
      this.fieldData = fieldData;
      this.openFieldDataDialog = true;
    }
  }
};
</script>
